<template>
    <v-container class="fill-height">
        <v-responsive class="align-center text-center fill-height">
            <v-card outlined max-width="560" class="mx-auto pt-3 pb-5 px-3">
                <v-card-title class="text-h4 justify-center">{{ $t("title") }}</v-card-title>
                <v-divider></v-divider>
                <v-card-text v-if="error" class="pb-0">
                    <v-alert :icon=false dense outlined dismissible type="error">{{ $t("authenticationFailed") }}: {{
                    errorMessage }}</v-alert>
                </v-card-text>
                <v-card-text class="pb-3">
                    <p class="text-center">{{ $t("subtitle") }}</p>
                    <v-form @submit.prevent="submit">
                        <v-otp-input autofocus length="6" v-model="mfa_token"></v-otp-input>
                    </v-form>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions class="mt-3">
                    <v-btn name="submit" color="primary" large @click="submit" block>{{ $t("submit") }}</v-btn>
                </v-card-actions>
            </v-card>
            <p class="text-center mt-5">
                <v-btn @click="cancel">{{ $t("cancel") }}</v-btn>
            </p>
            <v-overlay v-show=showOverlay :color="this.$vuetify.theme.dark ? '#000000' : '#FFFFFF'" opacity=1 z-index=500>
                <v-img v-if="this.$vuetify.theme.dark" height="50" width="300" :src="require('@/assets/logo-dark.png')"></v-img>
                <v-img v-else height="50" width="300" :src="require('@/assets/logo-light.png')"></v-img>
                <v-sheet color="transparent" class="ml-10 mr-10 mt-5">
                    <v-progress-linear indeterminate rounded></v-progress-linear>
                </v-sheet>
            </v-overlay>
        </v-responsive>
    </v-container>
</template>

<script>
export default {
    name: "MultiFactorAuthentication",
    props: ['username', 'session'],
    data() {
        return {
            mfa_token: null,
            error: null,
            errorMessage: null,
            emailRules: [
                value => {
                    if (value) return true
                    return this.$t('emailRequired');
                },
                value => {
                    if (/.+@.+\..+/.test(value)) return true
                    return this.$t('emailError');
                },
            ],
        };
    },
    methods: {
        submit() {
            this.showOverlay = true;
            this.$store.dispatch('submitChallenge', {
                username: this.username,
                session: this.session,
                mfa_token: this.mfa_token
            }).then(() => {
                this.sleep(1).then(() => {
                    if (this.$route.query.redirect != null) {
                        this.$router.push(this.$route.query.redirect);
                        this.$route.query.redirect = null;
                    } else {
                        this.$router.push("/home");
                    }
                }).catch((error) => {
                    console.log(error);
                });
            }).catch((error) => {
                this.showOverlay = false;
                this.error = true;
                this.errorMessage = error.response.data.errorDescription;
            })
        },
        sleep(ms) {
            return new Promise(resolve => setTimeout(resolve, ms));
        },
        cancel() {
            this.$emit('cancel');
        }
    },
};
</script>
<i18n>
  {
    "en": {
      "title" : "Multi-factor authentication",
      "subtitle" : "Your account is secured using multi-factor authentication (MFA). To finish signing in, check your email for a six digit code and enter it below.",
      "submit" : "Submit",
      "cancel" : "Cancel",
      "authenticationFailed" : "Authenication Failed"
    }
  }
  </i18n>